export default async function getRegistrosEventos() {
    try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/RegistrosEventos`);
        
        if (!response.ok) {
            throw new Error(`Erro: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        return [];
    }
}
